import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { Tab, Tabs } from "react-bootstrap";
import { LoadingComponent } from "Components";
import { EventBox } from "Components/Private/Events/EventBox";
import { newAuthService } from "Service/Axios";
import {
  getCreatedByEventListUrl,
  getRegisteredEventListUrl,
  getTrendingEventListUrl,
} from "Constant/api";
import { paths } from "Constant/paths";

export default function Events() {
  const { t } = useTranslation();

  const [loading, setLoading] = useState(false);
  const [createdByEventList, setCreatedByEventList] = useState([]);
  const [trendingEventList, setTrendingEventList] = useState([]);
  const [registeredEventList, setRegisteredEventList] = useState([]);

  //  Listing
  const getCreatedByEventList = async () => {
    setLoading(true);
    const payload = {};
    const response = await newAuthService(
      getCreatedByEventListUrl,
      "POST",
      payload
    );
    if (response.status) {
      setCreatedByEventList(response.data);
      setLoading(false);
    } else {
      setCreatedByEventList([]);
      setLoading(false);
    }
  };

  const getRegisteredEventList = async () => {
    setLoading(true);
    const payload = {};
    const response = await newAuthService(
      getRegisteredEventListUrl,
      "POST",
      payload
    );
    if (response.status) {
      setRegisteredEventList(response.data);
      setLoading(false);
    } else {
      setRegisteredEventList([]);
      setLoading(false);
    }
  };

  const getTrendingEventList = async () => {
    setLoading(true);
    const payload = {};
    const response = await newAuthService(
      getTrendingEventListUrl,
      "POST",
      payload
    );
    if (response.status) {
      setTrendingEventList(response.data);
      setLoading(false);
    } else {
      setTrendingEventList([]);
      setLoading(false);
    }
  };

  useEffect(() => {
    getCreatedByEventList();
    getRegisteredEventList();
    getTrendingEventList();
  }, []);

  return (
    <LoadingComponent isLoading={loading}>
      <main className="main">
        <div className="mb-4 p-4 rounded-3 bg-white">
          <div className="mb-3 p-4 text-white rounded-3 bg-gredient-1 position-relative overflow-hidden">
            <div className="parent-event-img position-absolute top-0 start-0 bottom-0 end-0">
              <img
                src="https://img.freepik.com/free-photo/free-time-students-bachelor-s-campus-life-rhythm-five-friendly-students-are-walking_8353-6408.jpg?t=st=1723899046~exp=1723902646~hmac=644b1ea53c82edda311982e259df875fd16cb1fbc5ad590a9f21a741377caaba&w=1380"
                alt=""
                className="w-100 h-100 object-fit-cover"
              />
            </div>
            <div className="row align-items-start gy-3 position-relative z-1">
              <div className="col-md-8 col-sm-12 col-12">
                <h2 className="h4">
                  Discover, Participate, and Earn: Enrich Your Campus Journey!
                </h2>
                <p>
                  Dive into a world of opportunities and fun on campus! Join any
                  event listed here and start earning coins with each
                  participation.
                </p>
                <a href="#" className="text-decoration-none text-white">
                  Know more
                </a>
              </div>
              <div className="col-md-4 col-sm-12 col-12 text-md-end">
                <Link className="btn btn-light" to={paths.admin.events.create}>
                  <i className="bx bxs-magic-wand bx-sm me-1 align-middle"></i>
                  Event Creation Wizard
                </Link>
              </div>
            </div>
          </div>

          <div>
            <div className="mb-3 position-relative">
              <div className="ms-md-auto position-absolute top-0 end-0">
                <div
                  className="btn-group btn-group"
                  role="group"
                  aria-label="Basic example"
                >
                  <button
                    type="button"
                    className="btn btn-outline-orange border-2 active"
                  >
                    <span className="material-symbols-outlined">
                      event_note
                    </span>
                  </button>
                  <button
                    type="button"
                    className="btn btn-outline-orange border-2"
                  >
                    <span className="material-symbols-outlined">tune</span>
                  </button>
                </div>
              </div>
              <div className="events-tabs">
                <Tabs
                  defaultActiveKey="registered"
                  id="events-tab"
                  className="mb-3 w-100"
                >
                  <Tab eventKey="registered" title="Events you are attending">
                    <div className="row gy-4">
                      {registeredEventList.length > 0 ? (
                        registeredEventList.map((event, idx) => (
                          <div
                            className="col-xxl-3 col-lg-4 col-md-6 col-sm-6 col-12"
                            key={`${event.gid}-${idx}`}
                          >
                            <EventBox event={event} />
                          </div>
                        ))
                      ) : (
                        <div className="col-12 text-center">
                          <p className="text-muted">
                            {t("common.messages.error.notFound.noEventsFound")}
                          </p>
                        </div>
                      )}
                    </div>
                  </Tab>
                  <Tab eventKey="created" title="Events you created">
                    <div className="row gy-4">
                      {createdByEventList.length > 0 ? (
                        createdByEventList.map((event, idx) => (
                          <div
                            className="col-xxl-3 col-lg-4 col-md-6 col-sm-6 col-12"
                            key={`${event.gid}-${idx}`}
                          >
                            <EventBox
                              event={event}
                              fetchEvent={getCreatedByEventList}
                            />
                          </div>
                        ))
                      ) : (
                        <div className="col-12 text-center">
                          <p className="text-muted">
                            {t("common.messages.error.notFound.noEventsFound")}
                          </p>
                        </div>
                      )}
                    </div>
                  </Tab>
                  <Tab eventKey="trending" title="Trending Events near you">
                    <div className="row gy-4">
                      {trendingEventList.length > 0 ? (
                        trendingEventList.map((event, idx) => (
                          <div
                            className="col-xxl-3 col-lg-4 col-md-6 col-sm-6 col-12"
                            key={`${event.gid}-${idx}`}
                          >
                            <EventBox event={event} />
                          </div>
                        ))
                      ) : (
                        <div className="col-12 text-center">
                          <p className="text-muted">
                            {t("common.messages.error.notFound.noEventsFound")}
                          </p>
                        </div>
                      )}
                    </div>
                  </Tab>
                </Tabs>
              </div>
            </div>
          </div>
        </div>
      </main>
    </LoadingComponent>
  );
}
